/**
 * @description: 是否电梯媒体
 * @param {*} mtypeId
 * @return {*}
 */
export function isElevatorType(mtypeId) {
    return isProjectionType(mtypeId) || isHallType(mtypeId);
}

/**
 * @description: 是否投影（电梯电子屏，电梯投影）
 * @param {*} mtypeId
 * @return {*}
 */
export function isProjectionType(mtypeId) {
    return [52, 178].includes(mtypeId);
}

/**
 * @description: 是否有等候厅（电梯海报、等候厅灯箱）
 * @param {*} mtypeId
 * @return {*}
 */
export function isHallType(mtypeId) {
    return [50, 266].includes(mtypeId);
}

/**
 * @description: 是否有日轮播
 * @param {*} mtypeId
 * @return {*}
 */
export function isCarousel(mtypeId) {
    return [52, 53, 178].includes(mtypeId);
}

/**
 * @description: 是否有梯内梯外
 * @param {*} mtypeId
 * @return {*}
 */
export function isElevatorOutside(mtypeId) {
    return [50, 57, 178].includes(mtypeId);
}

export function availableMedias() {
    return [{
        id: 50,
        label: '电梯海报'
    }, {
        id: 52,
        label: '电梯电子屏'
    }, {
        id: 53,
        label: '社区灯箱'
    }, {
        id: 56,
        label: '道闸'
    }, {
        id: 57,
        label: '横秀'
    }, {
        id: 178,
        label: '电梯投影'
    }, {
        id: 179,
        label: '社区门禁'
    }, {
        id: 249,
        label: '人行护栏'
    }, {
        id: 266,
        label: '等候厅灯箱'
    }];
}
